import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import en from 'locale/en/validator';
import es from 'locale/es/validator';
import validators from 'validators';

/* ===================
 * Custom Validations
 * ====================
 */
validators(Validator);

const dictionary = {
  en,
  es
};

const locale = document.querySelector('html').getAttribute('lang') || 'es';

Vue.use(VeeValidate, {
  locale,
  inject: false,
  dictionary // dictionary object
});
